<template>
	<header id="header" class="page-header gd-warning box-shadow sticky">
        <div class="navbar navbar-expand-lg">
            <!-- brand -->
            <a href="javascript:void(0)" class="navbar-brand text-white">
                <img src="/assets/img/logo-main.png" alt="...">
            </a>
            <!-- / brand -->
            <!-- Navbar collapse -->
            <div class="collapse navbar-collapse order-2 order-lg-1" id="navbarToggler">
                
            </div>
            <ul class="nav navbar-menu order-1 order-lg-2">
                <li class="nav-item d-none d-sm-block">
                    <a class="nav-link px-2" data-toggle="fullscreen" data-plugin="fullscreen">
                        <font-awesome-icon icon="fa-solid fa-maximize" />
                    </a>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link px-2" data-toggle="dropdown">
                        <font-awesome-icon icon="fa-solid fa-gear" />
                    </a>
                    <div class="dropdown-menu dropdown-menu-center mt-3 w-md animate fadeIn">
                        <div class="setting px-3">
                            <div class="mb-2 text-muted">
                                <strong>Setting:</strong>
                            </div>
                            <div class="mb-3" id="settingLayout">
                                <label class="ui-check ui-check-rounded my-1 d-block">
                                    <input type="checkbox" name="stickyHeader">
                                    <i></i>
                                    <small>Sticky header</small>
                                </label>
                                <label class="ui-check ui-check-rounded my-1 d-block">
                                    <input type="checkbox" name="stickyAside">
                                    <i></i>
                                    <small>Sticky aside</small>
                                </label>
                                <label class="ui-check ui-check-rounded my-1 d-block">
                                    <input type="checkbox" name="foldedAside">
                                    <i></i>
                                    <small>Folded Aside</small>
                                </label>
                                <label class="ui-check ui-check-rounded my-1 d-block">
                                    <input type="checkbox" name="hideAside">
                                    <i></i>
                                    <small>Hide Aside</small>
                                </label>
                            </div>
                            <div class="mb-2 text-muted">
                                <strong>Color:</strong>
                            </div>
                            <div class="mb-2">
                                <label class="radio radio-inline ui-check ui-check-md">
                                    <input type="radio" name="bg" value="">
                                    <i></i>
                                </label>
                                <label class="radio radio-inline ui-check ui-check-color ui-check-md">
                                    <input type="radio" name="bg" value="bg-dark">
                                    <i class="bg-dark"></i>
                                </label>
                            </div>
                            <div class="mb-2 text-muted">
                                <strong>Layouts:</strong>
                            </div>
                            <div class="mb-3">
                                <a href="dashboard.html" class="btn btn-xs btn-white no-ajax mb-1">Default</a>
                                <a href="layout.a.html?bg" class="btn btn-xs btn-primary no-ajax mb-1">A</a>
                                <a href="layout.b.html?bg" class="btn btn-xs btn-info no-ajax mb-1">B</a>
                                <a href="layout.c.html?bg" class="btn btn-xs btn-success no-ajax mb-1">C</a>
                                <a href="layout.d.html?bg" class="btn btn-xs btn-warning no-ajax mb-1">D</a>
                            </div>
                            
                            
                        </div>
                    </div>
                </li>
                <!-- Notification -->
                <li class="nav-item dropdown">
                    <a class="nav-link px-2 mr-lg-2" data-toggle="dropdown">
                        <font-awesome-icon icon="fa-regular fa-bell" />
                        <span class="badge badge-pill badge-up bg-primary">9</span>
                    </a>
                    <!-- dropdown -->
                    <div class="dropdown-menu dropdown-menu-right mt-3 w-md animate fadeIn p-0">
                        <div class="scrollable hover" style="max-height: 250px">
                            <div class="list list-row">
                                
                            </div>
                        </div>
                        <div class="d-flex px-3 py-2 b-t">
                            <div class="flex">
                                <span>0 Notifications</span>
                            </div>
                            <a href="page.setting.html">See all
                                <i class="fa fa-angle-right text-muted"></i>
                            </a>
                        </div>
                    </div>
                    <!-- / dropdown -->
                </li>
                <!-- User dropdown menu -->
                <li class="nav-item dropdown">
                    <a href="javascript:void(0)" data-toggle="dropdown" class="nav-link d-flex align-items-center px-2 text-color">
                        <span class="w-24 avatar gd-success">
		                      {{ avatar }}
		                </span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right w mt-3 animate fadeIn">
                        <a class="dropdown-item" href="javascript:void(0)">
                            <span>{{ username }}</span>
                        </a>
                        
                        <div class="dropdown-divider"></div>
                        <router-link to="/my_profile" class="dropdown-item">
                            <span>Profile</span>
                        </router-link>
                        <router-link to="/task" class="dropdown-item">
                            <span class="flex">Tasks</span>
                            <span><b class="badge badge-pill gd-warning">5</b></span>
                        </router-link>
                        <a class="dropdown-item" href="javascript:void(0)">Need help?</a>
                        <div class="dropdown-divider"></div>
                        <router-link to="/settings" class="dropdown-item">
                            <span>Account Settings</span>
                        </router-link>
                        <a class="dropdown-item" href="javascript:void(0)" @click="signOut">Sign out</a>
                    </div>
                </li>
                <!-- Navarbar toggle btn -->
                <li class="nav-item d-lg-none">
                    <a href="javascript:void(0)" class="nav-link px-2" data-toggle="collapse" data-toggle-class data-target="#navbarToggler">
                        <i data-feather="search"></i>
                    </a>
                </li>
                <li class="nav-item d-lg-none">
                    <a class="nav-link px-1" data-toggle="modal" data-target="#aside">
                        <i data-feather="menu"></i>
                    </a>
                </li>
            </ul>
        </div>
    </header>
</template>
<script>
export default {
  name: 'header',
  props: [],
  components: {
    Notification
  },
  data: function() {
    return {
      notification: [],
      formData: {
        
      },
      formRules: {

      }
    }
  },
  watch: {
    
  },
  computed: {
    
    avatar: function() {
      return localStorage.getItem('initial')
    },
    userRole: function() {
      return localStorage.getItem('role')
    },
    username: function() {
      return localStorage.getItem('username')
    }
  },
  methods: {
    signOut: function() {
      let that = this
      this.$http.post(this.API_PREFIX + 'account/logout').then(function (response) {
        that.$store.commit('signOut')
	    that.$router.push({
	      path: '/login'
	    })
	  }).catch(function (error) {
	    
	  })
    }
  },
  mounted: function() {
    
  }
}
</script>